import { SidebarBannerBuilderComponent } from '@tvlgiao/bc-supermarket-builder-components';
import React from 'react';
export default {
  SidebarBannerBuilderComponent,
  React
};